;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:{},n=(new e.Error).stack;n&&(e._sentryDebugIds=e._sentryDebugIds||{},e._sentryDebugIds[n]="4a3f8f3a-5e7e-4fd4-9c74-f4e0ace342e6",e._sentryDebugIdIdentifier="sentry-dbid-4a3f8f3a-5e7e-4fd4-9c74-f4e0ace342e6")}catch(e){}}();import _setPrototypeOf from './setPrototypeOf.js';

function _inheritsLoose(t, o) {
  t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o);
}

export { _inheritsLoose as default };
//# sourceMappingURL=inheritsLoose.js.map
